import {GlobalVariables} from "../GlobalVariables";

export default class Footer {
	constructor() {
		this.revealFooter();
		GlobalVariables.resizeCallbacks.push(this);
	}

	revealFooter(){
		const footer = document.querySelector('.footer-main');
		const wrapper = document.querySelector('.page-container');

		// On récupère la hauteur réelle du footer
		const footerHeight = ( window.innerWidth > 922 ) ? footer.offsetHeight : 0;

		// On applique cette hauteur en margin-bottom au contenu
		wrapper.style.marginBottom = `${footerHeight}px`;
	}

	resize(){
		this.revealFooter();
	}

}
